module.exports = __webpack_public_path__ + "static/media/pangea_data_model_full.9cebba20.jpg";